module.exports = __webpack_public_path__ + "assets/img/star_sentence_un8.48ddbcd6.png";